import React from "react";
import SignupForm from "../components/signup/SignupForm";

const SignupDemo = () => {
	return (
		<div>
			<SignupForm />
		</div>
	);
};

export default SignupDemo;
